import React, { useEffect } from 'react';
import { Error as ErrorIcon } from '@mui/icons-material';
import { EXTENSION_ERROR_MESSAGE } from 'common/constants/documents';
import { Alert } from 'components';
import useDocumentsContext from 'context/DocumentsContext';
import { useAppLoadAsyncOperations, useDocuments } from 'services/hooks';
import { UploadedFileAlertProps } from './FileAlerts.props';
import { POLL_TYPE } from '../../../../services/hooks/useAppLoadAsyncActions';
import ProgressBar from '../progress/ProgressBar';

const UploadedFileAlert = ({
  droppedFiles,
  file,
  validFileTypes,
  fromReferenceWidget,
  selectedMeasurementDateId,
  setIsFileUploaded,
  setFilesToSave,
  autoClassify = false,
}: UploadedFileAlertProps) => {
  const { validateAndUploadFile, progress, isValidType, setIsLoading } = useDocuments();
  const { currentDocuments, setCompanyDocuments } = useDocumentsContext();
  const { manuallyExecutePoll } = useAppLoadAsyncOperations(false);

  useEffect(() => {
    const execUpload = async () => {
      const fileProps = {
        file,
        fromReferenceWidget,
        mdId: selectedMeasurementDateId,
        currentDocumentsId: currentDocuments.id,
        files: currentDocuments.files,
        setCompanyDocumentsParam: setCompanyDocuments,
        setIsLoadingParam: setIsLoading,
        setIsFileUploaded,
        setFilesToSaveParam: setFilesToSave,
        autoClassify,
      };

      const fileCreateResponse = await validateAndUploadFile(fileProps);
      if ((fileCreateResponse as { generation_job_id: string }).generation_job_id) {
        manuallyExecutePoll(POLL_TYPE.GENERATION_JOBS);
      }
    };

    execUpload();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isValidType) {
    return <ProgressBar droppedFiles={droppedFiles} file={file} progress={progress} />;
  }

  return (
    <Alert isAlertVisible icon={<ErrorIcon />}>
      {EXTENSION_ERROR_MESSAGE(file)} {validFileTypes.join(', ').toUpperCase()}.
    </Alert>
  );
};

export default UploadedFileAlert;
